/**
 * Constant.
 */
var DAYS = 1000 * 60 * 60 * 24;
/**
 *
 * @param {number} timestamp
 * @param {number} otherTimestamp
 * @param {number} q
 * @return {number}
 */
var daysDiff = function (timestamp, otherTimestamp, q) {
    if (q === void 0) { q = 1; }
    var _timestamp = new Date(timestamp).getTime();
    var _otherTimestamp = new Date(otherTimestamp).getTime();
    var result = (_timestamp - _otherTimestamp) / q;
    return Number.isNaN(result) ? 0 : result;
};
var getUsageTime = function () {
    try {
        var t = localStorage.getItem('firebaseUsageTime') || '0';
        return parseInt(t);
    }
    catch (error) {
        window.captureException(error);
        return 0;
    }
};
/**
 *
 * @param {number} secondsInterval
 * @return {void}
 */
var measureUsageTime = function (secondsInterval) {
    if (secondsInterval === void 0) { secondsInterval = 30; }
    try {
        var usageTime_1 = getUsageTime();
        window.firebaseUsageTimeInterval = setInterval(function () {
            usageTime_1 += secondsInterval;
            localStorage.setItem('firebaseUsageTime', String(usageTime_1));
        }, 1000 * secondsInterval);
    }
    catch (error) {
        window.captureException(error);
    }
};
var getUserType = function () {
    try {
        var userType = localStorage.getItem('firebaseUserType');
        if (userType === null)
            return 'new_user';
        return userType;
    }
    catch (error) {
        window.captureException(error);
        return 'new_user';
    }
};
var storeUserType = function (userType) {
    try {
        localStorage.setItem('firebaseUserType', userType);
    }
    catch (error) {
        window.captureException(error);
    }
};
/**
 *
 * @param {UserType} userType
 * @return {void}
 */
var setUserType = function (userType) {
    try {
        var currentUserType = getUserType();
        if (currentUserType === userType)
            return;
        storeUserType(userType);
        window.Tracker.setUserProperty('user_type', userType, {
            event_name: 'user_type',
            event_label: 'user_type',
            event_value: userType,
        });
        // @ts-ignore
        window.flutterEventLog.unshift({ eventName: 'setUserType', data: { userType: userType } });
    }
    catch (error) {
        window.captureException(error);
    }
};
export { measureUsageTime, setUserType };
